import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import type { LivingType } from '../types';

export interface LivingTerms {
  partner1Default: string;
  partner2Default: string;
  partnerSingular: string;
  partnerPlural: string;
  groupName: string;
  groupPossessive: string;
  budgetDescription: string;
  incomeDescription: string;
  expenseDescription: string;
  settingsLabel: string;
  invitePartner: string;
  invitePartnerDescription: string;
  linkedMessage: string;
}

const LIVING_TERM_KEYS = [
  'partner1Default', 'partner2Default', 'partnerSingular', 'partnerPlural',
  'groupName', 'groupPossessive', 'budgetDescription', 'incomeDescription',
  'expenseDescription', 'settingsLabel', 'invitePartner',
  'invitePartnerDescription', 'linkedMessage',
] as const;

export function useLivingTerms(livingType: LivingType = 'couple'): LivingTerms {
  const { t } = useTranslation('settings');
  return useMemo(() => {
    const type = livingType === 'colocation' ? 'colocation' : 'couple';
    const terms = {} as LivingTerms;
    for (const key of LIVING_TERM_KEYS) {
      terms[key] = t(`livingTerms.${type}.${key}`);
    }
    return terms;
  }, [livingType, t]);
}

// Helper function pour obtenir le nom d'un partenaire avec fallback
export function getPartnerName(
  partnerNumber: 1 | 2,
  firstName: string | undefined | null,
  livingType: LivingType = 'couple'
): string {
  if (firstName) return firstName;

  const type = livingType === 'colocation' ? 'colocation' : 'couple';
  return i18next.t(`livingTerms.${type}.${partnerNumber === 1 ? 'partner1Default' : 'partner2Default'}`, { ns: 'settings' });
}
